import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import theme from '../theme/theme';
import { Link } from 'react-router-dom';

function NavIconButton({ icon, hint, title, to, size,onClick,className ,iconClassName,disabled=false}) {
const fontsSize= window.innerWidth < 550 ? '0.8rem' : '1rem';
 
return (
  <div
    className={`icon-bg-circle ${className} ${disabled ? 'disabled' : ''}`}
    style={{
      color: theme.colors.darkGray,
      pointerEvents: disabled ? 'none' : 'auto',
      opacity: disabled ? 0.5 : 1,
    }}
  >
    <Link 
      to={disabled ? '#' : to} 
      onClick={disabled ? undefined : onClick}
    >
      <FontAwesomeIcon 
        icon={icon} 
        className={`header-nav-icon ${iconClassName}`} 
        title={hint} 
        style={{ fontSize: size }} 
      />
    </Link>
    <span 
      className={`icon-title ${iconClassName}`} 
      style={{ fontSize: fontsSize }}
    >
      {title}
    </span>
  </div>
);
}

export default NavIconButton;
